export const FALLBACK_FILENAME = "downloaded-file";

export const parseFileNameFromDisposition = (contentDisposition = "") => {
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      return utf8Match[1].trim();
    }
  }

  const basicMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  return basicMatch?.[1] ? basicMatch[1] : FALLBACK_FILENAME;
};

export const sanitizeFileName = (value = "") => {
  if (!value || typeof value !== "string") {
    return "";
  }

  return value.replace(/<[^>]*>/g, "").trim();
};

export const triggerBlobDownload = (blobData, fileName) => {
  const name = fileName || FALLBACK_FILENAME;
  const blob = blobData instanceof Blob ? blobData : new Blob([blobData]);
  const blobUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = name;
  anchor.rel = "noopener";
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.dispatchEvent(
    new MouseEvent("click", { bubbles: false, cancelable: true, view: window }),
  );
  anchor.remove();
  window.setTimeout(() => {
    window.URL.revokeObjectURL(blobUrl);
  }, 40000);
};

export const downloadAxiosBlobResponse = (response, fileName) => {
  triggerBlobDownload(
    new Blob([response.data]),
    sanitizeFileName(fileName) || FALLBACK_FILENAME,
  );
};
